import { useState, useEffect } from "react";
import { Box, Checkbox, FormControlLabel, Typography, Stack } from "@mui/material";
import PropTypes from 'prop-types';
import SelectPoste from "./selectPoste";

function Samedi({ data_samedi_pair, data_samedi_impair, onSamediChange, triggerResetSamedi, is_benevole }) {

  const [samedi, setSamedi] = useState({
    c_08_10: '',
    c_09_11: '',
    c_10_12: '',
    c_11_13: '',
    c_12_14: '',
    c_13_15: '',
    c_14_16: '',
    c_15_17: '',
    c_16_18: '',
    c_17_19: '',
    c_18_20: '',
    c_19_21: '',
    c_20_22: '',
    c_21_23: '',
    c_22_00: '',
    c_23_01: '',
    c_00_02: '',
    repas_midi: false,
    repas_soir: false,
  });

  const [l_08_10, setL_08_10] = useState([]);
  const [l_09_11, setL_09_11] = useState([]);
  const [l_10_12, setL_10_12] = useState([]);
  const [l_11_13, setL_11_13] = useState([]);
  const [l_12_14, setL_12_14] = useState([]);
  const [l_13_15, setL_13_15] = useState([]);
  const [l_14_16, setL_14_16] = useState([]);
  const [l_15_17, setL_15_17] = useState([]);
  const [l_16_18, setL_16_18] = useState([]);
  const [l_17_19, setL_17_19] = useState([]);
  const [l_18_20, setL_18_20] = useState([]);
  const [l_19_21, setL_19_21] = useState([]);
  const [l_20_22, setL_20_22] = useState([]);
  const [l_21_23, setL_21_23] = useState([]);
  const [l_22_00, setL_22_00] = useState([]);
  const [l_23_01, setL_23_01] = useState([]);
  const [l_00_02, setL_00_02] = useState([]);

  //---------------------------------------------------------------------------
  // création des listes de postes pour les créneaux du samedi
  //---------------------------------------------------------------------------
  useEffect(() => {
    /*
    setL_08_10(data_samedi_pair.filter((ligne) => ligne[0] && ligne[0].trim().length > 0) // On garde seulement si ligne[0] n'est pas vide
      .map((ligne) => `${ligne[0]} (${ligne[2]}/${ligne[3]})`));     // On concatène les colonnes 0, 2 et 3
    setL_10_12(data_samedi_pair.filter((ligne) => ligne[4] && ligne[4].trim().length > 0)
      .map((ligne) => `${ligne[4]} (${ligne[6]}/${ligne[7]})`));
    setL_12_14(data_samedi_pair.filter((ligne) => ligne[8] && ligne[8].trim().length > 0)
      .map((ligne) => `${ligne[8]} (${ligne[10]}/${ligne[11]})`));
    setL_14_16(data_samedi_pair.filter((ligne) => ligne[12] && ligne[12].trim().length > 0)
      .map((ligne) => `${ligne[12]} (${ligne[14]}/${ligne[15]})`));
    setL_16_18(data_samedi_pair.filter((ligne) => ligne[16] && ligne[16].trim().length > 0)
      .map((ligne) => `${ligne[16]} (${ligne[18]}/${ligne[19]})`));
    setL_18_20(data_samedi_pair.filter((ligne) => ligne[20] && ligne[20].trim().length > 0)
      .map((ligne) => `${ligne[20]} (${ligne[22]}/${ligne[23]})`));
    setL_20_22(data_samedi_pair.filter((ligne) => ligne[24] && ligne[24].trim().length > 0)
      .map((ligne) => `${ligne[24]} (${ligne[26]}/${ligne[27]})`));
    setL_22_00(data_samedi_pair.filter((ligne) => ligne[28] && ligne[28].trim().length > 0)
      .map((ligne) => `${ligne[28]} (${ligne[30]}/${ligne[31]})`));
    setL_00_02(data_samedi_pair.filter((ligne) => ligne[32] && ligne[32].trim().length > 0)
      .map((ligne) => `${ligne[32]} (${ligne[34]}/${ligne[35]})`));
    */
    setL_08_10(data_samedi_pair.map((ligne) => ligne[0]).filter(str => str.trim().length > 0));
    setL_10_12(data_samedi_pair.map((ligne) => ligne[4]).filter(str => str.trim().length > 0));
    setL_12_14(data_samedi_pair.map((ligne) => ligne[8]).filter(str => str.trim().length > 0));
    setL_14_16(data_samedi_pair.map((ligne) => ligne[12]).filter(str => str.trim().length > 0));
    setL_16_18(data_samedi_pair.map((ligne) => ligne[16]).filter(str => str.trim().length > 0));
    setL_18_20(data_samedi_pair.map((ligne) => ligne[20]).filter(str => str.trim().length > 0));
    setL_20_22(data_samedi_pair.map((ligne) => ligne[24]).filter(str => str.trim().length > 0));
    setL_22_00(data_samedi_pair.map((ligne) => ligne[28]).filter(str => str.trim().length > 0));
    setL_00_02(data_samedi_pair.map((ligne) => ligne[32]).filter(str => str.trim().length > 0));
  }, [data_samedi_pair]);

  //---------------------------------------------------------------------------
  // création des listes de postes pour les créneaux du samedi
  //---------------------------------------------------------------------------
  useEffect(() => {
    /*
    setL_09_11(data_samedi_impair.filter((ligne) => ligne[0] && ligne[0].trim().length > 0)
      .map((ligne) => `${ligne[0]} (${ligne[2]}/${ligne[3]})`));
    setL_11_13(data_samedi_impair.filter((ligne) => ligne[4] && ligne[4].trim().length > 0)
      .map((ligne) => `${ligne[4]} (${ligne[6]}/${ligne[7]})`));
    setL_13_15(data_samedi_impair.filter((ligne) => ligne[8] && ligne[8].trim().length > 0)
      .map((ligne) => `${ligne[8]} (${ligne[10]}/${ligne[11]})`));
    setL_15_17(data_samedi_impair.filter((ligne) => ligne[12] && ligne[12].trim().length > 0)
      .map((ligne) => `${ligne[12]} (${ligne[14]}/${ligne[15]})`));
    setL_17_19(data_samedi_impair.filter((ligne) => ligne[16] && ligne[16].trim().length > 0)
      .map((ligne) => `${ligne[16]} (${ligne[18]}/${ligne[19]})`));
    setL_19_21(data_samedi_impair.filter((ligne) => ligne[20] && ligne[20].trim().length > 0)
      .map((ligne) => `${ligne[20]} (${ligne[22]}/${ligne[23]})`));
    setL_21_23(data_samedi_impair.filter((ligne) => ligne[24] && ligne[24].trim().length > 0)
      .map((ligne) => `${ligne[24]} (${ligne[26]}/${ligne[27]})`));
    setL_23_01(data_samedi_impair.filter((ligne) => ligne[28] && ligne[28].trim().length > 0)
      .map((ligne) => `${ligne[28]} (${ligne[30]}/${ligne[31]})`));
    */
    setL_09_11(data_samedi_impair.map((ligne) => ligne[0]).filter(str => str.trim().length > 0));
    setL_11_13(data_samedi_impair.map((ligne) => ligne[4]).filter(str => str.trim().length > 0));
    setL_13_15(data_samedi_impair.map((ligne) => ligne[8]).filter(str => str.trim().length > 0));
    setL_15_17(data_samedi_impair.map((ligne) => ligne[12]).filter(str => str.trim().length > 0));
    setL_17_19(data_samedi_impair.map((ligne) => ligne[16]).filter(str => str.trim().length > 0));
    setL_19_21(data_samedi_impair.map((ligne) => ligne[20]).filter(str => str.trim().length > 0));
    setL_21_23(data_samedi_impair.map((ligne) => ligne[24]).filter(str => str.trim().length > 0));
    setL_23_01(data_samedi_impair.map((ligne) => ligne[28]).filter(str => str.trim().length > 0));
  }, [data_samedi_impair]);

  //---------------------------------------------------------------------------
  // mise à jour des données dans le composant parent
  //---------------------------------------------------------------------------
  useEffect(() => {
    onSamediChange(samedi);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [samedi]);

  //---------------------------------------------------------------------------
  // reset des info du samedi
  //---------------------------------------------------------------------------
  useEffect(() => {
    if (triggerResetSamedi) {
      setSamedi({
        c_08_10: '',
        c_09_11: '',
        c_10_12: '',
        c_11_13: '',
        c_12_14: '',
        c_13_15: '',
        c_14_16: '',
        c_15_17: '',
        c_16_18: '',
        c_17_19: '',
        c_18_20: '',
        c_19_21: '',
        c_20_22: '',
        c_21_23: '',
        c_22_00: '',
        c_23_01: '',
        c_00_02: '',
        repas_midi: false,
        repas_soir: false,
      });
    }
  }, [triggerResetSamedi]);

  //---------------------------------------------------------------------------
  // HMI
  //---------------------------------------------------------------------------
  return (
    <Stack spacing={1} bgcolor={'#b6d7a8'} alignItems={'center'} sx={{ width: '100%' }}>
      <Typography variant="h6" align="center">
        Samedi
      </Typography>

      {is_benevole && (
        <Stack direction={'row'} sx={{ width: '100%' }}>
          <Stack spacing={1} sx={{ width: '50%' }}>
            <SelectPoste
              label="08h00-10h00"
              value={samedi.c_08_10}
              onChange={(event) => { setSamedi({ ...samedi, c_08_10: event.target.value }); }}
              items={l_08_10}
              creneau1={''}
              creneau2={samedi.c_09_11}
            />

            <SelectPoste
              label="10h00-12h00"
              value={samedi.c_10_12}
              onChange={(event) => { setSamedi({ ...samedi, c_10_12: event.target.value }); }}
              items={l_10_12}
              creneau1={samedi.c_09_11}
              creneau2={samedi.c_11_13}
            />

            <SelectPoste
              label="12h00-14h00"
              value={samedi.c_12_14}
              onChange={(event) => { setSamedi({ ...samedi, c_12_14: event.target.value }); }}
              items={l_12_14}
              creneau1={samedi.c_11_13}
              creneau2={samedi.c_13_15}
            />

            <SelectPoste
              label="14h00-16h00"
              value={samedi.c_14_16}
              onChange={(event) => { setSamedi({ ...samedi, c_14_16: event.target.value }); }}
              items={l_14_16}
              creneau1={samedi.c_13_15}
              creneau2={samedi.c_15_17}
            />

            <SelectPoste
              label="16h00-18h00"
              value={samedi.c_16_18}
              onChange={(event) => { setSamedi({ ...samedi, c_16_18: event.target.value }); }}
              items={l_16_18}
              creneau1={samedi.c_15_17}
              creneau2={samedi.c_17_19}
            />

            <SelectPoste
              label="18h00-20h00"
              value={samedi.c_18_20}
              onChange={(event) => { setSamedi({ ...samedi, c_18_20: event.target.value }); }}
              items={l_18_20}
              creneau1={samedi.c_17_19}
              creneau2={samedi.c_19_21}
            />

            <SelectPoste
              label="20h00-22h00"
              value={samedi.c_20_22}
              onChange={(event) => { setSamedi({ ...samedi, c_20_22: event.target.value }); }}
              items={l_20_22}
              creneau1={samedi.c_19_21}
              creneau2={samedi.c_21_23}
            />

            <SelectPoste
              label="22h00-00h00"
              value={samedi.c_22_00}
              onChange={(event) => { setSamedi({ ...samedi, c_22_00: event.target.value }); }}
              items={l_22_00}
              creneau1={samedi.c_21_23}
              creneau2={samedi.c_23_01}
              width="260px" />

            <SelectPoste
              label="00h00-02h00"
              value={samedi.c_00_02}
              onChange={(event) => { setSamedi({ ...samedi, c_00_02: event.target.value }); }}
              items={l_00_02}
              creneau1={samedi.c_23_01}
              creneau2={''}
            />
          </Stack>

          <Stack spacing={1} sx={{ width: '50%' }}>
            <Box sx={{ height: '15px' }} />
            <SelectPoste
              label="09h00-11h00"
              value={samedi.c_09_11}
              onChange={(event) => { setSamedi({ ...samedi, c_09_11: event.target.value }); }}
              items={l_09_11}
              creneau1={samedi.c_08_10}
              creneau2={samedi.c_10_12}
            />

            <SelectPoste
              label="11h00-13h00"
              value={samedi.c_11_13}
              onChange={(event) => { setSamedi({ ...samedi, c_11_13: event.target.value }); }}
              items={l_11_13}
              creneau1={samedi.c_10_12}
              creneau2={samedi.c_12_14}
            />

            <SelectPoste
              label="13h00-15h00"
              value={samedi.c_13_15}
              onChange={(event) => { setSamedi({ ...samedi, c_13_15: event.target.value }); }}
              items={l_13_15}
              creneau1={samedi.c_12_14}
              creneau2={samedi.c_14_16}
            />

            <SelectPoste
              label="15h00-17h00"
              value={samedi.c_15_17}
              onChange={(event) => { setSamedi({ ...samedi, c_15_17: event.target.value }); }}
              items={l_15_17}
              creneau1={samedi.c_14_16}
              creneau2={samedi.c_16_18}
            />

            <SelectPoste
              label="17h00-19h00"
              value={samedi.c_17_19}
              onChange={(event) => { setSamedi({ ...samedi, c_17_19: event.target.value }); }}
              items={l_17_19}
              creneau1={samedi.c_16_18}
              creneau2={samedi.c_18_20}
            />

            <SelectPoste
              label="19h00-21h00"
              value={samedi.c_19_21}
              onChange={(event) => { setSamedi({ ...samedi, c_19_21: event.target.value }); }}
              items={l_19_21}
              creneau1={samedi.c_18_20}
              creneau2={samedi.c_20_22}
            />

            <SelectPoste
              label="21h00-23h00"
              value={samedi.c_21_23}
              onChange={(event) => { setSamedi({ ...samedi, c_21_23: event.target.value }); }}
              items={l_21_23}
              creneau1={samedi.c_20_22}
              creneau2={samedi.c_22_00}
            />

            <SelectPoste
              label="23h00-01h00"
              value={samedi.c_23_01}
              onChange={(event) => { setSamedi({ ...samedi, c_23_01: event.target.value }); }}
              items={l_23_01}
              creneau1={samedi.c_22_00}
              creneau2={samedi.c_00_02}
            />
          </Stack>
        </Stack>
      )}

      <Stack direction={'row'} bgcolor={'#e69138'} sx={{ width: '100%' }}>
        <Stack alignItems={'center'} sx={{ width: '50%' }}>
          <FormControlLabel
            label="Repas samedi midi"
            control={
              <Checkbox
                checked={samedi.repas_midi}
                onChange={(event) => { setSamedi({ ...samedi, repas_midi: event.target.checked }); }}
              />} />
        </Stack>
        <Stack alignItems={'center'} sx={{ width: '50%' }}>
          <FormControlLabel
            label="Repas samedi soir"
            control={
              <Checkbox
                checked={samedi.repas_soir}
                onChange={(event) => { setSamedi({ ...samedi, repas_soir: event.target.checked }); }}
              />} />
        </Stack>
      </Stack>
    </Stack>

  );
};

Samedi.propTypes = {
  data_samedi_pair: PropTypes.any.isRequired,
  data_samedi_impair: PropTypes.any.isRequired,
  onSamediChange: PropTypes.any.isRequired,
  triggerResetSamedi: PropTypes.any.isRequired,
  is_benevole: PropTypes.any.isRequired
};

export default Samedi;